module.exports = __webpack_public_path__ + "img/dati-txt.0f0105ca.png";